import React, {useState, useEffect} from "react";
import {useHistory} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {message, Modal, Tooltip, Popconfirm, Table, Upload} from "antd";
import { SyncOutlined, ExclamationCircleOutlined, CloseCircleOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { fetchEventSource } from '@microsoft/fetch-event-source';

import Iconfont from "../Iconfont/Iconfont";
import {getSizeText} from "../../utils/tool";
import SplitUpload from "../SplitUpload/index-websocket";
import { setAIModalState } from "../../features/AIIntelligentV7/AIReducer";
import { cadType } from "../../utils/defaultValue";

import "./index.scss";

const UploadFileModalV7 = (props) => {

    const dispatch = useDispatch();
    
    const {
        onOk,
        uploadMultiple = true,
        uploadType = "parsingFiles",
        oCancel
    } = props;

    const history = useHistory();
    
    const [isChoiceFile, setIsChoiceFile]  = useState(true);

    const [okBtnDisabled, setOkBtnDisabled] = useState(true);
    const [cancelBtnDisabled, setCancelBtnDisabled] = useState(false);

    const [tableId, setTableId] = useState(`tableContentBox-${Math.random()}`);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [selectedFile, setSelectedFile] = useState([]);

    const [btnText, setBtnText] = useState('点击上传');

    const [fileLimitType, setFileLimitType] = useState([
        "application/pdf", // pdf
        "image/jpg", // jpg
        "image/png", // png
        "image/jpeg", // jpeg
        // "application/zip", // zip
        // "application/x-zip-compressed", // zip
        "application/msword", // doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
        // "application/vnd.ms-word.document.macroEnabled.12", // docm
        "application/vnd.ms-excel", // xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
        // "application/vnd.ms-excel.sheet.macroEnabled.12", // xlsm
        "application/vnd.ms-powerpoint", // ppt
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
        // "application/vnd.ms-powerpoint.presentation.macroEnabled.12", // pptm
    ]);

    const columns = [
        {
            dataIndex: "name",
            key: "name",
            title: "文件名",
            align: "left",
            render: (val, record, idx) => {
                // isScan 是否是扫描件 1是 0否
                if(record.otherData && record.otherData.isScan === 1){
                    return <span><Tooltip title="扫描件">
                        <Iconfont type={'icon-saomiaojianshangchuan'} />
                    </Tooltip>{val}</span>
                }else{
                    return val
                }
            }
        },
        {
            dataIndex: "size",
            key: "size",
            title: "大小",
            width: "100px",
            render: (val, record, idx) => {
                return getSizeText(val || 0, 'b')
            },
        },
        {
            dataIndex: "status",
            key: "status",
            title: "状态",
            width: "120px", 
            align: "left",
            render: (val, record, idx) => {
                let icon = "icon-time_fill";
                let text = "待上传";
                // 上传状态
                if (val === "success") {
                    icon = "icon-dui";
                    text = "上传成功";
                    
                } else if (val === "processing") {
                    let process = record.process ? `${Number(Math.round(record.process * 10000) / 100)}%` : "中";
                    icon = (<SyncOutlined spin />);
                    text = `上传${process}`;
                } else if (val === "fail") {
                    icon = "icon-locationiconfail";
                    text = record.msg || "上传失败";
                }

                return (
                    <span className="statusBox">{
                        (val === "processing") ? icon : 
                        (<Iconfont type={icon} />)}<span style={{ display: 'inline-block',
                            width: '75px',
                            marginLeft: '5px'}}>{text}</span></span>
                )
            },
        },
        {
            dataIndex: "operate",
            key: "operate",
            title: "操作",
            width: "100px",
            render: (val, record, idx) => {
                const {status} = record;
                return (
                    <div className="uploadOperateBox">
                        {
                            (!status || status === 'fail') ? (
                                <Popconfirm
                                    placement={"left"}
                                    title={"确定删除吗？"}
                                    okText={"确定"}
                                    cancelText={"取消"}
                                    onConfirm={() => deleteSelectFileFunc(record)}
                                    overlayClassName={"deletePupConfirmBox"}
                                >
                                    <span className="operateBtn deleteBtn">删除</span>
                                </Popconfirm>
                            ) : ("-")
                        }
                    </div>
                )
            },
        },
    ];
    const [fileList, setFileList] = useState([]);
    const [tableHeight, setTableHeight] = useState(0);

    useEffect(() => { 
        if(uploadType != 'aiAnalysis'){
            setFileLimitType([
                ...fileLimitType,
                "application/zip", // zip
                "application/x-zip-compressed", // zip
            ])
        }
    }, [uploadType])

    useEffect(() => {
        let dom = document.getElementById(tableId);
        if (dom) {
            setTableHeight(dom.clientHeight - 48);
        }
    })


    // useEffect(() => {
    //     if (newFileList.length > 0) {
    //         uploadFileCallBack(newFileList);
    //     }
    // }, [newFileList])

    // useEffect(() => {
    //     console.log(fileList,"fileListfileList")
    //     // 默认全选
    //     let fileIds = [];
    //     fileList.map(item=>{
    //         if(item.status === "success"){
    //             fileIds.push(item.fileId)
    //         }
    //     })
    //     setSelectedKeys(fileIds)
    // }, [okText, isChoiceFile, okBtnDisabled])

    useEffect(() => { 
        


        if(uploadType === "aiAnalysis"){
            // AI问答框限制只能上传3个文件
            if(selectedKeys.length > 0 && selectedKeys.length <= 3){
                setOkBtnDisabled(false);
            }else{
                setOkBtnDisabled(true);
            }
        }


        // 需要判断选中的数据是否已经上传完成
        let hasUpSuccess = true;
        selectedFile.map(item => { 
            if(item.status != "success"){
                hasUpSuccess = false;
            }
        })
        if(hasUpSuccess){
            // 全部上传完成
            if(uploadType === "aiAnalysis"){
                setBtnText('立即解析');
            }else{
                setBtnText('确定');
            }
        }else{
            // 如果没有上传完成
            setBtnText("点击上传");
        }

        
    }, [selectedKeys])

    // 已选择文件
    async function selectFilesChangeFunc(fileLists, state, e) {
        let list = [...fileList];
        let fileIds = [];
        for (const item of fileLists) {
            if (fileLimitType.includes(item.type)) {
                let encodeName = window.encodeURI(item.name);
                let idStr = `${item.lastModified}-${encodeName}-${item.size}-${item.type}-${Date.now()}`;
                item.fileId = window.btoa(idStr);
                list.push(item);
            }
        }
        list.map(item=>{
            fileIds.push(item.fileId)
        });

        console.log(list,fileIds,"hahahha")
        setFileList(list);
        if(uploadType === "common" || (uploadType === "aiAnalysis" && list.length <= 3)){
            // 默认全选
            setSelectedKeys(fileIds);
            setSelectedFile(list);
            setOkBtnDisabled(false);
        }
        // setOkBtnDisabled(false);
        if(e){
            e.target.value = "";
        }
    }
    
    const handleChange = (file, fileArray) => {
        let list = [...fileList];
        
        for (const item of fileArray) {
            if (fileLimitType.includes(item.type) || cadType.includes(item.name.split('.').pop())) {
                let encodeName = window.encodeURI(item.name);
                let idStr = `${item.lastModified}-${encodeName}-${item.size}-${item.type}-${Date.now()}`;
                item.fileId = window.btoa(idStr);
                list.push(item);
            }
        }

        console.log(list,"listlist")
        
        setFileList(list);
        // setOkBtnDisabled(false);

        return false;
    }

    // 删除文件
    function deleteSelectFileFunc (file) {
        let idx = fileList.findIndex(item => item.fileId === file.fileId);
        if (idx > -1) {
            let newFileList = [...fileList];
            newFileList.splice(idx, 1);
            if(newFileList && newFileList.length <= 0){
                console.log(newFileList,'文件全部删完了')
                // 文件全部删完了
                clearUploadFile(true);
            }
            setFileList(newFileList);
        }

        if(selectedKeys.indexOf(file.fileId) != -1){
            selectedKeys.splice(selectedKeys.indexOf(file.fileId), 1);
            setSelectedKeys(selectedKeys)
        }
    }


    // 上传文件执行函数
    const uploadFileCallBack = async (newFileList) => {

        if(uploadType === "aiAnalysis"){
            // ai问答限制总文件大小不能超过50M
            let size = 0;
            newFileList.map(items=>{
                size+= items.size;
                items.status = "processing"
            })

            // 文件大小不超过50M
            const fileize = 10485760*5;
            if(size > fileize){
                message.error(`文件大小不能超过50M`);
                return false;
            }
        }

        setIsChoiceFile(false); //上传文件按钮
        

        await SplitUpload(newFileList, (params, socket) => {
            const {status, process, fileId, otherData, linkStatus, msg} = params || {};
            console.log("上传后的数据params", params);

            let commonFileList = [];
            let flag = true; //是否全部上传成功
            let hasFailFile = false;
            let errorList = [];
            let successList = [];
            // isScan 是否是扫描件 1是 0否
            let scannedCopyList = [];

            if (linkStatus != 'stop' || status) {
                // 更新状态
                fileList.forEach((fileItem,index) => {
                    if(fileItem.fileId === fileId){
                        fileItem.status = status;
                        fileItem.process = process;
                        fileItem.otherData = otherData;
                    }
                    if(uploadType === "aiAnalysis" && (fileItem.otherData && fileItem.otherData.isScan === 1) && fileItem.status === "success"){
                        successList.push(fileItem);
                        fileItem.disabled = true;
                    }else if (fileItem.status === "success"){
                        successList.push(fileItem);
                        fileItem.disabled = false;
                    }else{
                        fileItem.disabled = true;
                    }
                    commonFileList.push(fileItem);
                })

                // 判断是否上传完成
                selectedFile.forEach((fileItems,index) => {
                    if(fileItems.fileId === fileId){
                        fileItems.status = status;
                        fileItems.process = process;
                        fileItems.otherData = otherData;
                    }

                    if(uploadType === "aiAnalysis" && (fileItems.otherData && fileItems.otherData.isScan === 1)){
                        scannedCopyList.push(fileItems.fileId);
                    }

                    if(fileItems.status === "fail"){
                        hasFailFile = true;
                        errorList.push(fileItems.fileId);
                    }


                    if (fileItems.status !== "success" && fileItems.status !== "fail") {
                        flag = false;
                    }
                })

                setFileList(commonFileList);
            }else{
                flag = false;
            }
                
            if (flag) {
                socket?.close();
                setOkBtnDisabled(false);
                if(uploadType === "aiAnalysis"){
                    setBtnText('立即解析');
                }else{
                    setBtnText('确定');
                }
                if(hasFailFile){
                    // 是否有上传失败的文件
                    // 把上传失败的文件取消勾选
                    // 扫描件也取消勾选
                    
                    
                    let _selectedKeys = [];
                    let _selectedFile = [];
                    let newErrorList = [...errorList];

                    
                    if(uploadType === "aiAnalysis" && scannedCopyList.length > 0){
                        // ai解析中不能上传扫描件
                        newErrorList = [...newErrorList,...scannedCopyList]
                    }


                    _selectedFile = selectedFile.filter(item => !newErrorList.includes(item.fileId));
                    _selectedKeys = selectedKeys.filter(item => !newErrorList.includes(item));

                    console.log(_selectedFile,"_selectedFile")
                    console.log(_selectedKeys,"_selectedKeys")
                    setSelectedKeys(_selectedKeys);
                    setSelectedFile(_selectedFile);
                    setIsChoiceFile(true); //上传文件按钮


                    // scannedCopyList

                //         setIsChoiceFile(true); //上传文件按钮
                //         setOkBtnDisabled(false);
                //         setCancelBtnDisabled(false);
                //     }else{
                        
                }else{
                    onOk({
                        fileList: successList
                    });
                    clearUploadFile();
                }

            }
        });
    }

    // 清除当前解析记录
    const clearUploadFile = async() => {
        setIsChoiceFile(true);
        setOkBtnDisabled(true);
        setCancelBtnDisabled(false);
        setBtnText("");
        setFileList([]);
        setSelectedKeys([]);
        setSelectedFile([]);
        dispatch(setAIModalState({
            uploadModalOpen: false,
        }))
        if(oCancel){
            oCancel();
        }
    }



    const state = {
        fileList,
        selectedKeys
    };

    return (
        <div className="uploadFileModalV7">
            <div className="uploadFileModalFrame">

                <div className="uploadBtn">
                    <div className={`choiceFileBtn ${isChoiceFile ? "" : "disabledChoiceFile"}`}>
                        <span className="btnText">选择文件</span>
                        {/* <Upload
                            // disabled={fileList.length >= 3}
                            beforeUpload={handleChange}
                            showUploadList={false}
                            fileList={fileList}
                            accept={fileLimitType.join(",")}
                            // maxCount={3}
                            multiple
                        >
                            <span className="btnText">选择文件</span>
                        </Upload> */}

                        
                        {/* 文件选择器 */}
                        {
                            isChoiceFile ? ( 
                                <input
                                    id="fileInput"
                                    type="file"
                                    multiple={uploadMultiple}
                                    accept={fileLimitType.join(",")}
                                    onChange={(e) => selectFilesChangeFunc(e.target.files, state, e)}
                                />
                            ) : undefined
                        }

                    </div>
                    <span className="tipText">支持批量上传文件{uploadType === "aiAnalysis"?'，AI问答不支持扫描件':'，压缩包仅支持ZIP格式'}</span>
                </div>

                <div className="tableContentBox" id={tableId}>
                    <Table
                        rowKey="fileId"
                        columns={columns}
                        bordered={false}
                        pagination={false}
                        dataSource={[...fileList]}
                        scroll={{y: tableHeight}}
                        rowSelection={{
                            type: "checkBox",
                            selectedRowKeys: selectedKeys,
                            onChange: (selectedRowKeys, selectedRows, info)=>{
                                console.log(selectedRowKeys, selectedRows, info)
                                setSelectedKeys(selectedRowKeys);
                                setSelectedFile(selectedRows)
                            },
                            getCheckboxProps: (record) => ({
                                disabled: record.disabled, 
                            }),
                        }}
                        locale={"点击上方”选择文件”或将文件拖拽到此区域"}
                    />
                    {
                        (fileList?.length < 1 && isChoiceFile) ? (
                            <div className="dragFileBox">
                                <span className="tipText">点击上方”选择文件"或将文件拖拽到此区域</span>
                                <input
                                    onDrop={(e, a) => {
                                        e?.preventDefault();
                                        const files = e.dataTransfer.files;
                                        selectFilesChangeFunc(files, state, e)
                                    }}
                                    id="fileInput2"
                                    type="file"
                                    multiple={true}
                                    accept={fileLimitType.join(",")}
                                    onChange={(e) => selectFilesChangeFunc(e.target.files, state, e)}
                                />
                            </div>
                        ) : undefined
                    }

                </div>

                {/* footBox */}
                <div className="footTips">{(uploadType === 'aiAnalysis' && selectedKeys.length > 3) && '最多可上传3个文件问答'}</div>
                <div className="footBox">
                    <span
                        className={`operateBtn cancelBtn ${cancelBtnDisabled ? "disabled" : ""}`}
                        onClick={() => {
                            if (cancelBtnDisabled) {
                                return
                            }
                            clearUploadFile();
                        }}
                    >取消上传</span>
                    
                    <span
                        className={`operateBtn confirmBtn ${okBtnDisabled ? "disabled" : ""}`}
                        onClick={() => {
                            if (okBtnDisabled) {
                                return
                            }

                            
                            if (selectedFile.length < 1) {
                                message.warning("请选择文件上传");
                                return false;
                            }

                            if(btnText === "立即解析" || btnText === '确定'){
                                onOk({
                                    fileList: selectedFile
                                });
                                clearUploadFile();
                            }else{
                                setOkBtnDisabled(true);
                                uploadFileCallBack(selectedFile)
                            }

                            
                        }}
                    >
                        {btnText}
                        {/* <span><CloudUploadOutlined />{btnText}</span> */}
                    </span>

                </div>

            </div>
        </div>
    );
};

UploadFileModalV7.propTypes = {
    onOk: PropTypes.func,
}

export default UploadFileModalV7;
